import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IStripePaymentState {
	isCardValid: boolean;
	cardPaymentError: string | undefined;
}

const INITIAL_STATE: IStripePaymentState = {
	isCardValid: false,
	cardPaymentError: undefined,
};

export const cardPaymentSlice = createSlice({
	name: 'cardPayment',
	initialState: INITIAL_STATE,
	reducers: {
		setCardPaymentErrorMessage: (state, action: PayloadAction<string | undefined>) => ({
			...state,
			cardPaymentError: action.payload,
		}),
		setCardValidFlag: (state, action: PayloadAction<boolean>) => ({
			...state,
			isCardValid: action.payload,
		}),
	},
});

export const { setCardPaymentErrorMessage, setCardValidFlag } = cardPaymentSlice.actions;

export default cardPaymentSlice.reducer;
